<template>
    <div class="main-area">
        <AdminTable
            :headers="[
                { key: 'clientName', name: 'Client' },
                { key: 'uploadedAt', name: 'Uploaded At', format: (val) => val ? Utils.renderTime(val) : 'N/A' }
            ]"
            :header="'Pending Agreements'"
            :subheader="'Agreement List'"
            :data="agreements ? agreements?.map(el => ({
               clientName: el.username,
               uploadedAt: new Date(el.user_upload_date),
               accountId: el.account_id,
            })) : []"
            @row-click="click"
            class="table-main w-full"
        >
        </AdminTable>
    </div>
</template>


<script setup>

    import { ref, computed, onMounted } from 'vue';
    import store from '@/store/index';
    import AdminTable from '@/components/AdminTable.vue';
    import Utils from '@/utils/index.js';
    import { useRouter } from 'vue-router';


    const router = useRouter()
    const agreements = computed(() => store.state.pendingAgreements);

    const tableData = ref([]);

    function click(el) {
        router.push(`/admin/users/${el.accountId}`)
    }


    // onMounted( () => {
    //     agreements.value.forEach( el => {
    //         tableData.push({
    //             clientName: ''
    //         })
    //     })
    // })


</script>


<style lang="scss" scoped>

    .main-area {
        padding: 20px;
        height: 90vh;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 1350px;
        margin: auto;
    }
</style>